import PropTypes from 'prop-types';
import cx from 'classnames';

const Icon = ({
  className,
  color,
  fill,
  height,
  id,
  img,
  omitViewBox = false,
  viewBox = '0 0 40 40',
  width,
  dataURI,
  ariaLabel = '',
  iconScale = 1,
  background,
  foreground,
}) => (
  <span aria-hidden className="icon-container">
    <svg
      id={id}
      style={{
        color: color || null,
        fill: fill || color || null,
        height: height ? `${height}em` : null,
        width: width ? `${width}em` : null,
        outline: 0,
      }}
      viewBox={!omitViewBox ? viewBox : null}
      className={cx('icon', className)}
      aria-label={ariaLabel}
      transform={
        background?.props?.shape === 'stopsign'
          ? 'translate(0, -3.33)'
          : undefined
      }
    >
      {background}
      <g
        style={{
          color: color || null,
          fill: color || null,
          height: height ? `${height}em` : null,
          width: width ? `${width}em` : null,
          outline: 0,
          transformOrigin: 'center',
          transform: `scale(${iconScale})`,
        }}
      >
        {dataURI ? (
          <image href={dataURI} x={0} y={0} width="100%" height="100%" />
        ) : (
          <use xlinkHref={`#${img}`} />
        )}
      </g>
    </svg>
    {foreground}
  </span>
);

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  fill: PropTypes.string,
  height: PropTypes.number,
  id: PropTypes.string,
  img: PropTypes.string.isRequired,
  omitViewBox: PropTypes.bool,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  dataURI: PropTypes.string,
  ariaLabel: PropTypes.string,
  iconScale: PropTypes.number,
  background: PropTypes.node,
  foreground: PropTypes.node,
};

Icon.displayName = 'Icon';
Icon.description = 'Shows an icon from the SVG sprite';

export default Icon;
